import { useNavigate } from "@tanstack/react-router"

import { useAuthStateChanges } from "@repo/supabase/hooks/use-auth-state-changes"
import { useUpdateUser } from "@repo/supabase/hooks/use-update-user"
import { toast } from "@repo/ui/components/ui/sonner"

export function useQuickPasswordUpdate() {
  const updateUser = useUpdateUser()
  const navigate = useNavigate()

  useAuthStateChanges({
    async onEvent(event) {
      if (event === "PASSWORD_RECOVERY") {
        const newPassword = prompt(
          "What would you like your new password to be?",
        )

        if (!newPassword) {
          return
        }

        return updateUser.mutate(
          {
            attributes: {
              password: newPassword,
            },
            options: {
              emailRedirectTo: window.location.origin,
            },
          },
          {
            onSuccess() {
              toast.success("Password updated successfully!")
            },
            onError() {
              toast.error("There was an error updating your password.")
            },
          },
        )
      }

      // After the user updates their password, navigate them back to the home page.
      if (event === "USER_UPDATED") {
        navigate({
          to: "/",
        })
      }
    },
  })
}
